/**
 * Convercus BI Service
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const ResultFreshness = {
    Fresh: 'fresh',
    Stale: 'stale',
    Computing: 'computing'
} as const;
export type ResultFreshness = typeof ResultFreshness[keyof typeof ResultFreshness];

